/**
 * Horizontal nested menu.
 */
const menu_nested_horizontal = (args) => {
    let doc = document.documentElement;
    let menu = args.menu;
    let hoverTimeouts = [];
    let debounceTimeout;
    const debounceDelay = 100;

    /**
     * This disables 2nd level sub menus from reacting to mouse hovers
     * when the 1st level sub menu doesn't fit the screen.
     */
    const disableHoversWhenParentOutOfBounds = true;

    if (!menu) {
        return;
    }

    if (!H_Tools?.nestedmenu) {
        return;
    }

    /**
     * Event: Handle mouse enter hover
     */
    function menuItemMouseEnter(e) {
        // console.log('Mouse entered menu item');

        // clear any previously set closing timeout
        while (hoverTimeouts.length > 0) {
            const timeout = hoverTimeouts.pop();
            clearTimeout(timeout);
        }

        if (disableHoversWhenParentOutOfBounds) {
            const ul = e.currentTarget.children[1];

            if (
                ul &&
                ul.classList.contains('-level-1') &&
                ul.classList.contains('-is-out-of-bounds-top-and-bottom')
            ) {
                return;
            }

            const parent_ul = e.currentTarget.parentElement;

            if (
                parent_ul &&
                parent_ul.classList.contains('-level-1') &&
                parent_ul.classList.contains('-is-out-of-bounds-top-and-bottom')
            ) {
                return;
            }

            const grandparent_ul = parent_ul.parentElement.parentElement;

            if (
                grandparent_ul &&
                grandparent_ul.classList.contains('-level-1') &&
                grandparent_ul.classList.contains(
                    '-is-out-of-bounds-top-and-bottom'
                )
            ) {
                return;
            }
        }

        // deactivate all <li> that are not part of this DOM tree
        const ancestors = H_Tools.ancestors.getAllAncestors(
            e.currentTarget,
            menu,
            'menu-item-has-children'
        );
        const li_with_children = menu.querySelectorAll(
            '.menu-item-has-children'
        );
        for (let i = 0; i < li_with_children.length; i++) {
            if (
                li_with_children[i] !== e.currentTarget &&
                ancestors.indexOf(li_with_children[i]) === -1
            ) {
                H_Tools?.nestedmenu?.deactivateMenuItem(li_with_children[i]);
            }
        }

        // activate hovered <li>
        H_Tools?.nestedmenu?.activateMenuItem(menu, e.currentTarget);
    }

    /**
     * Event: Handle mouseleave hover
     *
     * Close menu when hover timer has ended (only for horizontal menus)
     */
    function menuItemMouseLeave(e) {
        // console.log('Mouse left menu item');

        if (disableHoversWhenParentOutOfBounds) {
            const parent_ul = e.currentTarget.parentElement;

            if (
                parent_ul &&
                parent_ul.classList.contains('-level-1') &&
                parent_ul.classList.contains('-is-out-of-bounds-top-and-bottom')
            ) {
                return;
            }
        }

        // delay closing for more natural hover
        hoverTimeouts.push(
            setTimeout(
                function (li) {
                    H_Tools?.nestedmenu?.deactivateMenuItem(li);
                },
                750,
                e.currentTarget
            )
        );
    }

    /**
     * Adjust the position of the sub menu of the supplied menu item.
     *
     * @param li Menu item
     */
    function adjustSubMenuPosition(li) {
        // console.log('Adjusting position of sub menu...');

        const ul = li.children[1];

        if (!ul) {
            return;
        }

        // Remove all modifiers before fetching client rect
        ul.classList.remove('-is-out-of-bounds-right');
        ul.classList.remove('-is-out-of-bounds-bottom');
        ul.classList.remove('-is-out-of-bounds-top-and-bottom');

        const ul_rect = ul.getBoundingClientRect();

        if (ul_rect.width === 0) {
            return;
        }

        // If the submenu overflows the viewport on the right
        if (
            ul_rect.left + ul_rect.width + 10 >
            (window.innerWidth || doc.clientWidth)
        ) {
            ul.classList.add('-is-out-of-bounds-right');
        }

        const li_rect = li.getBoundingClientRect();

        // If the submenu overflows the viewport on the bottom
        if (
            ul_rect.top + ul_rect.height >
            (window.innerHeight || doc.clientHeight)
        ) {
            // If the submenu would not fit on the screen when bottom aligned
            if (li_rect.top + li_rect.height < ul_rect.height) {
                ul.style.setProperty('--position-y', `${ul_rect.y}px`);
                ul.classList.add('-is-out-of-bounds-top-and-bottom');
            }

            // If the submenu would fit on the screen when bottom aligned
            else {
                ul.classList.add('-is-out-of-bounds-bottom');
            }
        }
    }

    function subMenuOpened(e) {
        // console.log('Submenu opened');
        adjustSubMenuPosition(e.currentTarget);
    }

    function viewportResized() {
        // console.log('Viewport resized');
        menu.querySelectorAll('.menu-item-has-children').forEach((item) => {
            adjustSubMenuPosition(item);
        });
    }

    function caretOpened(e) {
        // console.log('Caret opened');

        if (!disableHoversWhenParentOutOfBounds) {
            return;
        }
        const ul = e.currentTarget.children[1];

        if (
            !ul ||
            !ul.classList.contains('-level-1') ||
            !ul.classList.contains('-is-out-of-bounds-top-and-bottom')
        ) {
            return;
        }

        // TODO: Close siblings
    }

    // setup hooks for menu items
    menu.querySelectorAll('.menu-item').forEach((item) => {
        item.addEventListener('mouseenter', menuItemMouseEnter);
        item.addEventListener('mouseleave', menuItemMouseLeave);
        item.addEventListener('submenuopened', subMenuOpened);
        item.addEventListener('caretopened', caretOpened);
    });

    // setup resize observer to update sub menu positions
    new ResizeObserver(() => {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            viewportResized();
        }, debounceDelay);
    }).observe(document.body);
};

document.querySelectorAll('.js-menu-nested-horizontal').forEach((menu) => {
    menu_nested_horizontal({
        menu: menu,
    });
});
